import { render } from "./MruDetails.vue?vue&type=template&id=6ade53f4&scoped=true"
import script from "./MruDetails.vue?vue&type=script&lang=js"
export * from "./MruDetails.vue?vue&type=script&lang=js"

import "./MruDetails.vue?vue&type=style&index=0&id=6ade53f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ade53f4"]])

export default __exports__